import React, { useState } from "react";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye, faComment, faHeart, faCheck, faEllipsisV } from '@fortawesome/free-solid-svg-icons';
import { Card, Form, Button, Table, InputGroup, Pagination } from '@themesberg/react-bootstrap';

export default () => {
  const [searchTerm, setSearchTerm] = useState("");

  const favoriteMessages = [
    {
      id: 1,
      sender: { name: "test", avatar: "" },
      receiver: { name: "Senem", avatar: "" },
      message: "vffg",
      date: "07-11-2025 02:48"
    },
    {
      id: 2,
      sender: { name: "Madine", avatar: "" },
      receiver: { name: "test", avatar: "" },
      message: "cfşgg",
      date: "07-11-2025 02:48"
    },
    {
      id: 3,
      sender: { name: "test", avatar: "" },
      receiver: { name: "Zeynep", avatar: "" },
      message: "cmzor",
      date: "07-11-2025 02:48"
    }
  ];

  return (
    <>
      <div className="py-4">
        <h4>Favori Mesajlar</h4>
      </div>

      <Card className="border-0 shadow-sm mb-4">
        <Card.Body>
          <div className="alert alert-info mb-4">
            <strong>Uyarı:</strong> Bu özellikleri test amaçıyla kullanabileceksiniz.
          </div>

          <div className="mb-4">
            <InputGroup>
              <Form.Control
                type="text"
                placeholder="Ara..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              />
              <Button variant="primary">Ara</Button>
            </InputGroup>
          </div>

          <div className="table-responsive">
            <Table className="table-dark table-hover mb-0" style={{ fontSize: '0.9rem' }}>
              <thead>
                <tr>
                  <th style={{ width: '50px' }}>#</th>
                  <th style={{ width: '200px' }}>Gönderen Üye</th>
                  <th style={{ width: '200px' }}>Alıcı Üye</th>
                  <th>Mesaj</th>
                  <th style={{ width: '180px' }}>Tarih</th>
                  <th style={{ width: '200px' }}>İşlem</th>
                </tr>
              </thead>
              <tbody>
                {favoriteMessages.map((msg, index) => (
                  <tr key={msg.id}>
                    <td className="text-center">{index + 1}</td>
                    <td>
                      <div className="d-flex flex-column align-items-center">
                        <div 
                          className="rounded-circle bg-secondary mb-1" 
                          style={{ width: 50, height: 50 }}
                        ></div>
                        <small>{msg.sender.name}</small>
                      </div>
                    </td>
                    <td>
                      <div className="d-flex flex-column align-items-center">
                        <div 
                          className="rounded-circle bg-secondary mb-1" 
                          style={{ width: 50, height: 50 }}
                        ></div>
                        <small>{msg.receiver.name}</small>
                      </div>
                    </td>
                    <td className="align-middle">{msg.message}</td>
                    <td className="align-middle">{msg.date}</td>
                    <td>
                      <div className="d-flex gap-1 justify-content-center">
                        <Button 
                          variant="light" 
                          size="sm" 
                          className="p-2"
                          style={{ width: '35px', height: '35px' }}
                        >
                          <FontAwesomeIcon icon={faEye} />
                        </Button>
                        <Button 
                          variant="light" 
                          size="sm" 
                          className="p-2"
                          style={{ width: '35px', height: '35px' }}
                        >
                          <FontAwesomeIcon icon={faComment} />
                        </Button>
                        <Button 
                          variant="light" 
                          size="sm" 
                          className="p-2"
                          style={{ width: '35px', height: '35px' }}
                        >
                          <FontAwesomeIcon icon={faHeart} />
                        </Button>
                        <Button 
                          variant="light" 
                          size="sm" 
                          className="p-2"
                          style={{ width: '35px', height: '35px' }}
                        >
                          <FontAwesomeIcon icon={faCheck} />
                        </Button>
                        <Button 
                          variant="light" 
                          size="sm" 
                          className="p-2"
                          style={{ width: '35px', height: '35px' }}
                        >
                          <FontAwesomeIcon icon={faEllipsisV} />
                        </Button>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </div>

          <div className="d-flex justify-content-center mt-3">
            <Pagination className="mb-0">
              <Pagination.First />
              <Pagination.Prev />
              <Pagination.Item active>{1}</Pagination.Item>
              <Pagination.Next />
              <Pagination.Last />
            </Pagination>
          </div>
        </Card.Body>
      </Card>
    </>
  );
};
